import { Modal } from "antd";
import Styles from "../css/payWithQuickbucks.module.scss";
import Cancel from "../../../../assets/cancel.svg";
import Caution from "../../../../assets/cautionsuccessicons.svg";
const PayWithQuickbucksModalSuccess = (props: any) => {
  return (
    <div>
      <Modal
        title="Basic Modal"
        destroyOnClose={true}
        width={500}
        centered
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
         
        <div
          className={Styles.modalContentVerification}
          style={{paddingBottom: "1.5rem" }}
        >
          {/* <div className={Styles.cancelDiv}>
            <img
              onClick={props.handleCancel}
              src={Cancel}
              className={Styles.cancelIcon}
              alt="horse"
            />
          </div> */}
          
          <div className={Styles.cautionDiv} style={{ marginTop: "1rem" }}>
            <img
              onClick={props.handleCancel}
              src={Caution}
              className={Styles.cautionIcon}
              alt="horse"
            />
          </div>
          <div style={{ textAlign: "center" }} className={Styles.titles}>
            Request submitted successfully
          </div>
          <div style={{ textAlign: "center" }} className={Styles.descThree}>
            Your loan request has been made successfully and is currently being
            processed. You will be notified when processing is complete. Check
            your notifications panel for further info
          </div>
          <button onClick={props.goToHistory} className={Styles.btn}>
            RETURN TO VENDOR
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbucksModalSuccess;
